module.exports = __webpack_public_path__ + "img/galeria-pets-3.e6461ec9.jpg";